import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import {
    ScenarioData,
} from '../../@types/_scenario';

// ----------------------------------------------------------------------

type ScenarioState = {
    isLoading: boolean;
    error: boolean;
    scenarios: ScenarioData[];
};

const initialState: ScenarioState = {
    isLoading: false,
    error: false,
    scenarios: [],
};

const slice = createSlice({
    name: 'scenario',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET SCENARIOS
        getScenariosSuccess(state, action) {
            state.isLoading = false;
            state.scenarios = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;

// Actions
export const { } = slice.actions;

// ----------------------------------------------------------------------

export function getScenarios(p_id: string) {
    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const searchParams = new URLSearchParams({ p_id });
            const response = await axios.get('/scenario/query/placeId?' + searchParams.toString());
            dispatch(slice.actions.getScenariosSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
